"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATES_SCHEMAS = void 0;
const domain_1 = require("@home-health-notify/domain");
const ADD_DELETE_DISCIPLINE_1 = __importDefault(require("./ADD_DELETE_DISCIPLINE"));
const AIDE_FIRST_VISIT_1 = __importDefault(require("./AIDE_FIRST_VISIT"));
const AIDE_LAST_VISIT_1 = __importDefault(require("./AIDE_LAST_VISIT"));
const DC_OASIS_1 = __importDefault(require("./DC_OASIS"));
const DC_SUMMARY_1 = __importDefault(require("./DC_SUMMARY"));
const EVAL_1 = __importDefault(require("./EVAL"));
const HANDS_OFF_1 = __importDefault(require("./HANDS_OFF"));
const MISSED_VISIT_1 = __importDefault(require("./MISSED_VISIT"));
const RECERT_1 = __importDefault(require("./RECERT"));
const REVISIT_1 = __importDefault(require("./REVISIT"));
const ROC_1 = __importDefault(require("./ROC"));
const SCHEDULE_CANCEL_VISIT_1 = __importDefault(require("./SCHEDULE_CANCEL_VISIT"));
const SCHEDULE_EVAL_1 = __importDefault(require("./SCHEDULE_EVAL"));
const SCHEDULE_FIRST_VISIT_1 = __importDefault(require("./SCHEDULE_FIRST_VISIT"));
const SCHEDULE_ROC_1 = __importDefault(require("./SCHEDULE_ROC"));
const SCHEDULE_SOC_1 = __importDefault(require("./SCHEDULE_SOC"));
const SOC_1 = __importDefault(require("./SOC"));
const TELE_MEDICINE_1 = __importDefault(require("./TELE_MEDICINE"));
const TRANSFER_1 = __importDefault(require("./TRANSFER"));
const UPDATE_SERVICE_TEMPLATE_1 = __importDefault(require("./UPDATE_SERVICE_TEMPLATE"));
const VITAL_1 = __importDefault(require("./VITAL"));
exports.TEMPLATES_SCHEMAS = {
    [domain_1.TEMPLATES.UPDATE_SERVICE_TEMPLATE]: UPDATE_SERVICE_TEMPLATE_1.default,
    [domain_1.TEMPLATES.SOC]: SOC_1.default,
    [domain_1.TEMPLATES.TRANSFER_OASIS]: TRANSFER_1.default,
    [domain_1.TEMPLATES.ROC]: ROC_1.default,
    [domain_1.TEMPLATES.REVISIT]: REVISIT_1.default,
    [domain_1.TEMPLATES.DC_SUMMARY]: DC_SUMMARY_1.default,
    [domain_1.TEMPLATES.DC_OASIS]: DC_OASIS_1.default,
    [domain_1.TEMPLATES.AIDE_FIRST_VISIT]: AIDE_FIRST_VISIT_1.default,
    [domain_1.TEMPLATES.AIDE_LAST_VISIT]: AIDE_LAST_VISIT_1.default,
    [domain_1.TEMPLATES.RECERT]: RECERT_1.default,
    [domain_1.TEMPLATES.EVAL]: EVAL_1.default,
    [domain_1.TEMPLATES.ADD_DELETE_DISCIPLINE]: ADD_DELETE_DISCIPLINE_1.default,
    [domain_1.TEMPLATES.HANDS_OFF]: HANDS_OFF_1.default,
    [domain_1.TEMPLATES.VITAL]: VITAL_1.default,
    [domain_1.TEMPLATES.SCHEDULE_SOC]: SCHEDULE_SOC_1.default,
    [domain_1.TEMPLATES.SCHEDULE_EVAL]: SCHEDULE_EVAL_1.default,
    [domain_1.TEMPLATES.MISSED_VISIT]: MISSED_VISIT_1.default,
    [domain_1.TEMPLATES.SCHEDULE_FIRST_VISIT]: SCHEDULE_FIRST_VISIT_1.default,
    [domain_1.TEMPLATES.TELE_MEDICINE]: TELE_MEDICINE_1.default,
    [domain_1.TEMPLATES.SCHEDULE_ROC]: SCHEDULE_ROC_1.default,
    [domain_1.TEMPLATES.SCHEDULE_CANCEL_VISIT]: SCHEDULE_CANCEL_VISIT_1.default,
};
__exportStar(require("./LAB_REQUISITION"), exports);
